// Наследуем свойства и методы базового объекта
var ReferenceRecordModel = BaseObjectModel.extend({
  className: "ReferenceRecordModel",

  /**
  * Выполняет прикладной метод.
  * @function ReferenceRecordModel.executeEntityMethod
  * @param {string} methodName Имя метода.
  * @param {object[]} opt_parameters Параметры, с которыми должен вызываться метод.
  * @since 5.5.0.1000
  
  * @example 
  * WebAccess.current.executeEntityMethod('MethodName').done(function(result) { console.log(result); });
  */
  executeEntityMethod: function (methodName, opt_parameters) {
    var d = $.Deferred();
    var me = this;
    var parameters = Array.prototype.slice.call(arguments, 1);

    var viewName = me.ReferenceView === 'undefined' ? "" : me.ReferenceView;
    WA.domainMethods.executeEntityMethod("/api/Reference.asmx/ExecuteEntityMethod",
      new WA.Link(this.ID, OBJECT_TYPE.REFERENCE_RECORD, this.ReferenceCode),
      viewName, methodName, parameters).done(function (res) {
        var changes = res.Changes;
        var changedMultiSelects = res.ChangedMultiSelectRequisitesValues;
        if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);

        d.resolve(res.MethodResult);
      }).fail(function (errorMessage, res) {
        if (res) {
          if (res.Result) {
            var data = res.Result;
            var changes = data.Changes;
            var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
            if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);
          }
          d.reject(res.Error);
        } else {
          d.reject(errorMessage);
        }
      });

    return d.promise();
  },

  /**
   * Проверяет, доступнен ли метод для текущего справочника.
   * @function ReferenceRecordModel.isMethodAvailable
   * @param {string} methodName Имя метода.
   * @return {boolean} True – прикладной метод доступен для текущего справочника, иначе False.
   * @since 5.5.0.1000
   */
  isMethodAvailable: function (methodName) {
    return WA.domainMethods.isMethodAvailable("/api/Reference.asmx/IsEntityMethodAvailable", new WA.Link(this.ID, OBJECT_TYPE.REFERENCE_RECORD, this.ReferenceCode), methodName);
  }
});